import { extractMentionedTabs } from '#pplx/frontend/apps/ask/ask-input/query-serialization/lexicalNodeToQuery.js';
import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useEffect, useRef } from 'react';
/** Synchronizes tab attachments with the tab mentions added to or removed from the input. */
export function useMentionTabAttachments({ userInputJson, }) {
    const { actions: { addAttachedTab, removeAttachedTab }, } = useCometState();
    const previousMentionedTabIdsRef = useRef([]);
    useEffect(() => {
        const currentMentionedTabs = extractMentionedTabs(userInputJson?.root);
        const currentTabIds = currentMentionedTabs.map((t) => t.id);
        const previousTabIds = previousMentionedTabIdsRef.current;
        const addedTabs = currentMentionedTabs.filter((tab) => !previousTabIds.includes(tab.id));
        const removedTabIds = previousTabIds.filter((id) => !currentTabIds.includes(id));
        addedTabs.forEach((tab) => addAttachedTab(tab));
        removedTabIds.forEach((id) => removeAttachedTab(id));
        previousMentionedTabIdsRef.current = currentTabIds;
    }, [userInputJson, addAttachedTab, removeAttachedTab]);
}
//# sourceMappingURL=useMentionTabAttachments.js.map